import Box from "@material-ui/core/Box";
import budget_quote_300x69 from "Custom/Content/User/budget_quote_UPDATE4-300x69.png";
import budget_quote_370x85 from "Custom/Content/User/budget_quote_UPDATE4-370x85.png";
import budget_quote from "Custom/Content/User/budget_quote_UPDATE4.png";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";
import styled from "styled-components";

export const DescriptionBox: any = styled(Box)`
    padding: 15px;

    .sectiontitle {
        font-weight: 700;
        font-size: 15px;
    }

    ul {
        font-family: "Helvetica Neue", Helvetica, sans-serif;
        font-weight: 300;
        font-size: 15px;
        line-height: 24px;
    }

    .bugetQuote {
        background-position-x: 0%;
        background-position-y: 0%;
        background-size: auto;
        background-repeat: no-repeat;
        background-origin: padding-box;
    }

    .budgetcaption {
        font-size: 15px;
        line-height: 24px;
        padding: 15px 0;
    }

    .descriptionGutter,
    .descriptionRoof {
        padding-bottom: 15px;
    }

    @media only screen and (max-width: ${breakpointTheme.breakpoints.values.md + "px"}) {
        .bugetQuote {
            background-image: url(${budget_quote_300x69});
            height: 65px;
        }
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.md + "px"}) and (max-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        .bugetQuote {
            background-image: url(${budget_quote_370x85});
            height: 85px;
        }
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        .bugetQuote {
            background-image: url(${budget_quote});
            max-width: 720px;
            height: 110px;
        }
    }
`;
